import React from 'react';
import { Link } from 'react-router-dom';

const Maintenance = () => {
  return (
    <div className=' container p-5 mb-4 rounded-3'>
      <div className='container-fluid py-5'>
        <h1 className='display-5 fw-bold text-muted'>Under maintenance</h1>
        <p className='col-md-8 fs-4'>
          The page is under Maintenance. Check later for update...
        </p>
        <Link className='btn btn-dark btn-lg' to='/' type='button'>
          Home page
        </Link>
      </div>
    </div>
  );
};

export default Maintenance;
